import Vue from 'vue'
import App from './App'
import router from './router'

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import axios from 'axios'
import VueAxios from 'vue-axios'

UIkit.use(Icons);
Vue.use(VueAxios, axios)

var config

if (window.location.hostname == "localhost") {
  config = {
    env: "Development",
    id: "d262ae823435d20a7b8dbcc5f2e8a8db",
    name: "DEVELOPMENT PAGINA"
  }
}

if (window.location.hostname == "del.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "d262ae823435d20a7b8dbcc5f2e8a8db",
    name: "Draagt Elkanders Lasten"
  }
}

if (window.location.hostname == "vanderweegh.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "3bfd4f59d7c61e6c40387ccf3071b8c2",
    name: "Van der Weegh persoonlijke uitvaartzorg"
  }
}

if (window.location.hostname == "corridor.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "3f936e5a597de69139ce7117a40229fe",
    name: "Corridor"
  }
}

if (window.location.hostname == "uitvaartzorgnop.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "3bfd4f59d7c61e6c40387ccf3071b8c2",
    name: "Uitvaart Noordoostpolder"
  }
}

if (window.location.hostname == "visser.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "4a309bc46f6a1f456f275c6d8e1ea20a",
    name: "Visser"
  }
}

if (window.location.hostname == "holtland.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "6a57ba950aeff2dbad7c812243dc03de",
    name: "Holtland"
  }
}

if (window.location.hostname == "vandijk.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "6a57ba950aeff2dbad7c812243dc03dd",
    name: "van dijk uitvaartverzorging"
  }
}

if (window.location.hostname == "anneliesvente.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "866fb01ae37245c3b21cde9224993e94",
    name: "Annelies Vente"
  }
}

if (window.location.hostname == "gz.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "5eaf783b819146789a2bbe912181cd4e",
    name: "Gedenkstenen Zwolle"
  }
}

if (window.location.hostname == "test.weerstandgrafmonumenten.nl") {
  config = {
    env: "Productie",
    id: "d262ae823435d20a7b8dbcc5f2e8a8db",
    name: "Test"
  }
}

if (!config) {
  config = {
    env: "Productie",
    id: "d262ae823435d20a7b8dbcc5f2e8a8db",
    name: "Draagt Elkanders Lasten"
  }
}

Vue.prototype.config = config

if (config.env == "Development") {
  console.log("RUNNING ON DEVELOPMENT")
}

Vue.config.productionTip = false

new Vue({
  el: '#app',
  data: {
  	check: null,
  },
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js